import { Role, ContentTypeRender } from "nystem-components";

const TravelsRole = ({ model, path }) => (
  <Role role={model.role} className={model.className}>
    <ContentTypeRender path={path} items={model.item} />
  </Role>
);

export default TravelsRole;
